import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = 'vote/2020project/2020greening/controller.php?enews=';
// 列表
export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};

// 列表
export const getlist = () => {
  return http.get(`${baseUrl}vote-list`);
};
// 用户信息
export const getUserInfo = () => {
  return http.get(`${baseUrl}user-info`);
};
export const getRankList = (date: any, page: any) => {
  return http.get(`${baseUrl}rank&time=${date}&page=${page}`);
};

export const getScore = (
  state: any,
  answerId: any,
  id: any,
  isTrue: any,
  time: any,
  answerTime: any,
) => {
  const data = {
    state,
    answer_id: answerId,
    id,
    true: isTrue,
    answer_time: answerTime,
    time,
  };

  return http.post(`${baseUrl}score`, qs.stringify(data));
};

export const getOneRank = () => {
  return http.get(`${baseUrl}one-rank`);
};
